import { reducer } from '../reducers/account';
import { accountRootSaga } from '../sagas/account';
import { saga, store } from '../store';

store.addReducers({ account: reducer });
saga.run(accountRootSaga);
